const setStatus = message => document.querySelector('#formStatus').innerHTML = message

document.addEventListener('DOMContentLoaded', function () {
  setTimeout(() => {
    const footerform = document.querySelector('form.klaviyo-form [data-testid="form-row"]')
    footerform.style.display = "block"
    footerform.querySelectorAll('[data-testid="form-component"]').forEach((div) => {
      div.style.width = "100%"
      div.style.padding = "0 0 10px 0"
      const button = div.querySelector("button")
      if (button) {
        button.style.width = "100%"
        button.style.fontFamily = "suse-regular"
        button.style.transition = "all 0.3s ease-in-out"
        button.style.padding = "0"
        button.classList.add("btn")
        if (window.innerWidth < 750) {
          button.style.fontSize = "18px"
        }
      }
    })
  }, 1000)
});